import * as React from 'react'

export default function Footer() {
  return (
    <footer className='footer text-center'>
      <p>© Royal FloraHolland</p>
    </footer>
  )
}
